import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import TopBar from "../../../app/layout/TopBar";
import ConsultantSidebar from "./ConsultantSidebar";

export default function ConsultantLayout() {
  return (
    <Box sx={{ height: "100dvh", display: "flex", flexDirection: "column", overflow: "hidden", bgcolor: "neutral.100" }}>
      <Box sx={{ p: 2, pb: 0 }}>
        <TopBar />
      </Box>

      <Box sx={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
        <ConsultantSidebar />
        <Box component="main" sx={{ flex: 1, minWidth: 0, minHeight: 0, overflowY: "auto", overflowX: "hidden" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
